import {
  ApiOutlined,
  CheckOutlined,
  GlobalOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import {
  AvatarDropdown as CoreAvatarDropdown,
  type CoreUserMenuItem,
  useLocale,
  useShell,
} from '@zhiyue/core';
import { BizAppConfig } from 'config/application.manifest';
import React from 'react';

type AvatarDropdownProps = {
  onOpenSettings?: () => void;
};

const AvatarDropdown: React.FC<AvatarDropdownProps> = ({ onOpenSettings }) => {
  const { locale, setLocale } = useLocale();
  const { shellConfig } = useShell();
  const languageTitle =
    shellConfig.ui.locales.find((item) => item.key === locale)?.title || '语言';

  const extraItems = React.useMemo<CoreUserMenuItem[]>(
    () => [
      {
        key: 'appSettings',
        icon: <SettingOutlined />,
        label: '设置',
      },
      ...(BizAppConfig.appOpenPlatformUrl
        ? [
            {
              key: 'openPlatform',
              icon: <ApiOutlined />,
              label: '开放平台',
            },
          ]
        : []),
      {
        key: 'help',
        icon: <QuestionCircleOutlined />,
        label: '帮助与文档',
      },
      { type: 'divider' },
      {
        key: 'languageHeading',
        icon: <GlobalOutlined />,
        label: languageTitle,
        disabled: true,
      },
      ...shellConfig.ui.locales.map((item) => ({
        key: `locale:${item.key}`,
        label: (
          <span className="app-user-menu-language-item">
            <span>
              <span role="img" aria-label={item.label}>
                {item.icon || '🌐'}
              </span>{' '}
              {item.label}
            </span>
            {item.key === locale ? <CheckOutlined /> : null}
          </span>
        ),
      })),
    ],
    [languageTitle, locale, shellConfig.ui.locales],
  );

  return (
    <span className="business-trip-avatar-dropdown">
      <CoreAvatarDropdown
        appId={BizAppConfig.appSsoClientId}
        personalCenterUrl={BizAppConfig.appPersonalCenterUrl}
        tenantManagementUrl={BizAppConfig.appTenantManagementUrl}
        workbenchUrl={BizAppConfig.appWorkbenchUrl}
        items={extraItems}
        mergeDefaultItems
        onAction={(key) => {
          if (key === 'appSettings') {
            onOpenSettings?.();
            return;
          }
          if (key === 'help') {
            const helpUrl = shellConfig.ui.links.help;
            if (helpUrl) window.open(helpUrl, '_blank', 'noopener,noreferrer');
            return;
          }
          if (key === 'openPlatform') {
            const openPlatformUrl = BizAppConfig.appOpenPlatformUrl;
            if (openPlatformUrl) window.open(openPlatformUrl, '_self');
            return;
          }
          if (key.startsWith('locale:')) {
            setLocale(key.slice('locale:'.length));
          }
        }}
      />
    </span>
  );
};

export default AvatarDropdown;
